<template>
    <div style="margin-top: 20px;padding-bottom:10px;">
        <el-collapse v-if="task_list.length > 0">
            <template v-for="item in task_list">
                <el-collapse-item :title="item.task_name" :name="item.id" :key="item.id">
                    <template slot="title">
                        <span style="color:#f56c6c;font-size:15px;">[{{ item.valid_status }}]</span>
                        <span style="color:#409eff;margin-left:10px;">{{ item.task_name }}</span>
                        <span style="color:#e6a23c;font-size:15px;font-weight:normal;margin-left:15px;">[{{ item.effective_date }} ~ {{ item.expiration_date }}]</span>
                    </template>
                    <el-table
                    :data="item.rc_result_list"
                    style="width: 100%"
                    stripe>
                        <el-table-column type="index"></el-table-column>
                        <el-table-column prop="report_type" label="报告类型" min-width="25%"></el-table-column>
                        <el-table-column prop="subordinate_name" label="下属姓名" min-width="20%"></el-table-column>
                        <el-table-column prop="behavior_score" label="离职风险评估得分" min-width="24%"></el-table-column>
                        <el-table-column prop="behavior_submit_date" label="提交日期" min-width="18%"></el-table-column>
                        <el-table-column prop="operations" label="操作" min-width="8%">
                            <template slot-scope="scope">
                                <el-button
                                size="mini"
                                type="primary"
                                :disabled="!scope.row.enable"
                                @click="viewReport(scope.row, item.id)">查看</el-button>
                                <!-- <el-button
                                size="mini"
                                type="warning"
                                :disabled="!scope.row.enable"
                                @click="downloadReport(scope.row, item.id)">下载</el-button> -->
                            </template>
                        </el-table-column>
                    </el-table>
                </el-collapse-item>
            </template>
        </el-collapse>
        <el-dialog 
        title="" 
        :visible.sync="dialogFormVisible" 
        width="1000px" 
        :destroy-on-close="true" 
        :close-on-click-modal="false">
            <!-- 这里直接引用scope.row中的属性无效，所以用form引用该row，通过form去引用对应的元素 -->
            <template slot="title">
                <span v-if="report_type=='personal_report'" style="font-weight:bold;font-size:18px;">查看结果-个人报告</span>
                <span v-else style="font-weight:bold;font-size:18px;">查看结果-团队报告（离职风险）</span>
            </template>
            <div style="text-align:left;">
            <el-button
            size="mini"
            type="primary"
            @click="downloadReport('personal_details')">下载</el-button></div>
            <result-details 
            ref="result_details"
            :rc_result_info="rc_result_info"
            :report_type="report_type"
            id="personal_details">
            </result-details>
        </el-dialog>
        <el-dialog 
        title="" 
        :visible.sync="dialogFormVisible_plotMotivations" 
        width="1000px" 
        :destroy-on-close="true" 
        :close-on-click-modal="false"
        @open="start_plot_motivations">
            <!-- 这里直接引用scope.row中的属性无效，所以用form引用该row，通过form去引用对应的元素 -->
            <template slot="title">
                <span style="font-weight:bold;font-size:18px;">查看结果-团队报告（动机结果）</span>
            </template>
            <div style="text-align:left;">
            <el-button
            size="mini"
            type="primary"
            @click="downloadReport('group_details1')">下载</el-button></div>
            <div id="group_details1">
                <div style="text-align:left;">
                    <p style="font-size:17px;font-weight:bold;">
                        <span>下属人数：</span><span style="color:#409EFF;font-weight:bold;">{{ subordinate_count }}</span>
                    </p>
                </div>
                <div id="plot1" style="width:900px;height:800px;"></div>
                <div id="plot2" style="width:900px;height:800px;"></div>
            </div>
        </el-dialog>
        <el-dialog 
        title="" 
        :visible.sync="dialogFormVisible_plotResource" 
        width="1000px" 
        :destroy-on-close="true" 
        :close-on-click-modal="false"
        @open="start_plot_resource">
            <!-- 这里直接引用scope.row中的属性无效，所以用form引用该row，通过form去引用对应的元素 -->
            <template slot="title">
                <span style="font-weight:bold;font-size:18px;">查看结果-团队报告（激励资源）</span>
            </template>
            <div style="text-align:left;">
            <el-button
            size="mini"
            type="primary"
            @click="downloadReport('group_details2')">下载</el-button></div>
            <div id="group_details2">
                <div id="plot3" style="width:900px;height:800px;margin-top:15px;"></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import resultDetails from './RC_results_details.vue';
import getdata from "@/api/getData.js";
import PdfLoader from "../../api/htmlToPdf.js";
export default {
    created() {
        this.getRCReportList();
    },
    data() {
        return {
            dialogFormVisible: false,
            dialogFormVisible_plotMotivations: false,
            dialogFormVisible_plotResource: false,
            task_list: [],
            form: {},
            rc_result_info: null,
            report_type: 'personal_report',
            sat_plot_result: {},
            imp_plot_result: {},
            resource_plot_result: {},
            subordinate_count: 0,
        }
    },
    components: {
        resultDetails,
    },
    methods: {
        downloadReport(id) {
            let report_name;
            if(this.form['report_type']=='个人报告'){
                report_name = '个人报告-' + this.form['subordinate_name'];
            }else{
                report_name = this.form['report_type'];
            }
            this.$nextTick(() => {
                let ele = document.getElementById(id);
                let pdf = new PdfLoader(ele, report_name, "el-table__row");
                pdf.getPDF();
            })
        },
        start_plot_motivations() {
            this.$nextTick(() => {
                this.plot('plot1', this.sat_plot_result);
                this.plot('plot2', this.imp_plot_result);
            });
        },
        start_plot_resource() {
            this.$nextTick(() => {
                this.plot('plot3', this.resource_plot_result);
            });
        },
        getRCReportList() {
            getdata.getList("getRCReportList")
            .then(resp => {
                if(resp.data.code == 200){
                    this.task_list = resp.data.data;
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        viewReport(row, task_id) {
            this.form = row;
            this.form['task_id'] = task_id;
            let params = {
                task_id: task_id,
                user_id: this.form['user_id'],
                superior_id: this.form['superior_id'],
                }
            // 根据报告类型，获取相应的数据 
            if(this.form['report_type']=='个人报告') {
                this.report_type = 'personal_report';
                getdata.getListP("getRCPersonalReport", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.rc_result_info = resp.data.data;
                        this.dialogFormVisible = true;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            }else if(this.form['report_type']=='团队报告-动机结果') {
                getdata.getListP("getRCMotivationReport", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.sat_plot_result = resp.data.sat_result;
                        this.imp_plot_result = resp.data.imp_result;
                        this.subordinate_count = resp.data.subordinate_count;
                        this.dialogFormVisible_plotMotivations = true;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            }else if(this.form['report_type']=='团队报告-激励资源') {
                getdata.getListP("getRCResourceReport", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.resource_plot_result = resp.data.data;
                        this.dialogFormVisible_plotResource = true;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            }else if(this.form['report_type']=='团队报告-离职风险') {
                this.report_type = 'group_report';
                getdata.getListP("getRCRetentionRiskReport", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.rc_result_info = resp.data.data;
                        this.dialogFormVisible = true;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            }
        },
        plot(id, p_data) {
            let echarts = require('echarts');
            // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
            let myChart = echarts.init(document.getElementById(id));
            // 指定图表的配置项和数据
            let option = {
                title: {
                    text: p_data.title
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                    type: 'shadow'
                    }
                },
                legend: {},
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01]
                },
                yAxis: {
                    type: 'category',
                    data: p_data.yAxis_data
                },
                series: p_data.series
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        },
    },
}
</script>

<style scoped>
::v-deep .el-table__header {
    font-size: 16px;
}
.el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
}
</style>